import type { TonyteActivity } from '../types';

const firstString = (...values: unknown[]) => {
  for (const value of values) {
    if (typeof value === 'string' && value.trim()) return value.trim();
  }
  return '';
};

export function getResolvedEventId(event?: Pick<TonyteActivity, 'id' | 'eventId' | 'canonicalEventId'> | null): string {
  return firstString(event?.canonicalEventId, event?.eventId, event?.id);
}

